import { Component } from '@angular/core';
import { AppService } from './app.service'
import { Router, Params, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { set } from 'lodash';

@Component({
    selector: 'logout',
    providers: [AppService],
    template: `
    <div class="col-sm-4 form-group">
        <h1>Logout</h1>
        <p>You have been successfully logged out.</p>
    </div>`
})
export class LogoutComponent {

    typeSelected: string;

    constructor(private _service: AppService, private _router: ActivatedRoute, private router: Router, private spinnerService: NgxSpinnerService) {
        this.typeSelected = 'ball-fussion';
    }

    ngOnInit() {
        console.log("LogoutComponent initialized");
        this.showSpinner()
        
        setTimeout(() => {
            this._service.logout();
            this.spinnerService.hide();
        }, 3000); // 1 second
    }

    public showSpinner(): void {
        this.spinnerService.show();
    }

}
